var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('p', {
    staticClass: "page--text text-center mb-20 mb-lg-40"
  }, [_c('span', [_vm._v(" 면접 일정 선택을 위한 면접 가능 시간을 선택하세요. ")]), _vm._v(" "), _c('br'), _c('span', [_vm._v(" 매칭 기간 개인회원이 면접 시간을 선택해야 매칭이 완료되며 개인회원의 연락처는 면접기간에 공개됩니다. ")])]), _c('v-card', {
    staticClass: "py-16 px-24",
    attrs: {
      "flat": "",
      "color": "grey-f1",
      "rounded": "lg"
    }
  }, [_c('p', {
    staticClass: "page--text text-center mb-10"
  }, [_c('span', [_vm._v(" 인터뷰 가능 시간을 선택해주세요. ")]), _vm._v(" "), _c('br'), _c('span', [_vm._v(" 개인 회원이 인터뷰 시간을 선택해야 매칭이 완료되며, 매칭 데이가종료된 후 개인 회원의 연락처가 공개됩니다. ")])]), _c('p', {
    staticClass: "page--text text-center mb-10"
  }, [_c('span', [_vm._v(" 온라인 면접을 선택하시면, 마이스펙에서제공하는 비대면면접 영상 미팅 기능을 이용하실 수 있습니다. ")]), _vm._v(" "), _c('br'), _c('span', [_vm._v(" 면접 시간에 맞춰 면접 정보에서 온라인 면접 버튼을 클릭해주세요. ")])]), _c('p', {
    staticClass: "page--text text-center font-weight-medium primary--text"
  }, [_c('span', [_vm._v(" 매칭이 완료되면 수정이 불가능하니, 신중하게 등록해주시기 바랍니다. ")])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }